export default "__VITE_ASSET__35241702__"